import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Link from '@mui/material/Link';
import DeckSelectionDropdownView from "./DeckSelectionDropdownView";
import NavbarSearchBarView from "./NavbarSearchBarView";
import {UserMenu} from "../../auth/components/UserMenu";
import {useDeck} from "../../deck-management/context/DeckContext";
import {useNavbarSearchView} from "../hooks/useNavbarSearchView";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import {SxProps, Theme} from "@mui/material/styles";


export default function NavigationBarView({displayDeckSelectionDropdown, displaySearchBar, displayVocabularyLink} : {displayDeckSelectionDropdown: boolean, displaySearchBar: boolean, displayVocabularyLink: boolean}) {

    const {currentDeck} = useDeck();
    const {
        isOpen,
        toggleOpen,
        searchText,
        setSearchText,
        selectedWord,
        highlightedIndex,
        setHighlightedIndex,
        inputRef,
        anchorRef,
        results,
        lemmaColumnWidth,
        posColumnWidth,
        showResults,
        closeAndReset,
        handleResultClick,
        handleInputKeyDown,
        closeWordInfoView,
    } = useNavbarSearchView();

    const showSearch = displaySearchBar && !!currentDeck;

    const renderVocabularyLink = (sx: SxProps<Theme>) => (
        <Link href="/vocabulary" sx={{color: 'inherit', ...sx}} underline="hover">
            Vocabulary
        </Link>
    );

    const renderSearchIcon = (sx: SxProps<Theme>) => (
        <IconButton onClick={toggleOpen} sx={{color: 'inherit', ...sx}}>
            <SearchIcon/>
        </IconButton>
    );

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static">
                <Toolbar sx={{px: 0}}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" width="100%" sx={{mx: {xs: 1, sm: 0}}}>
                        <Box display="flex" alignItems="center" >
                            <Link href="/">
                                <Box component="img" alt="logo" src="logo.png" sx={{display: {xs: 'none', sm: 'block'}}}/>
                                <Box component="img" alt="logo" src="logo_small.png" sx={{display: {xs: 'block', sm: 'none'}}}/>
                            </Link>
                            {displayVocabularyLink && renderVocabularyLink({ml: 1.5, display: {xs: 'inline-block', sm: 'none'}})}
                            {showSearch && renderSearchIcon({ml: 1.5, display: {xs: 'inline-flex', sm: 'none'}})}
                        </Box>

                        <Box display="flex" alignItems="center">
                            {displayVocabularyLink && renderVocabularyLink({mr: 1.5, display: {xs: 'none', sm: 'inline-block'}})}
                            {showSearch && renderSearchIcon({mr: 1.5, display: {xs: 'none', sm: 'inline-flex'}})}
                            {displayDeckSelectionDropdown && <DeckSelectionDropdownView/>}
                            <UserMenu/>
                            <Box sx={{flexGrow: 1}}/>
                        </Box>
                    </Box>
                </Toolbar>
            </AppBar>
            {showSearch && (isOpen || !!selectedWord) && (
                <NavbarSearchBarView
                    isOpen={isOpen}
                    searchText={searchText}
                    setSearchText={setSearchText}
                    selectedWord={selectedWord}
                    highlightedIndex={highlightedIndex}
                    setHighlightedIndex={setHighlightedIndex}
                    inputRef={inputRef}
                    anchorRef={anchorRef}
                    results={results}
                    lemmaColumnWidth={lemmaColumnWidth}
                    posColumnWidth={posColumnWidth}
                    showResults={showResults}
                    closeAndReset={closeAndReset}
                    handleResultClick={handleResultClick}
                    handleInputKeyDown={handleInputKeyDown}
                    closeWordInfoView={closeWordInfoView}
                />
            )}
        </Box>
    );
}
